import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "modal_content" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "modal_form" }
const _hoisted_4 = { class: "service_wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "cerificate__content !tw-border-none"
}
const _hoisted_6 = { class: "left_block" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", null, "Services", -1)
const _hoisted_8 = { class: "left_block__content" }
const _hoisted_9 = { class: "left_block__content__item" }
const _hoisted_10 = {
  key: 0,
  class: "service__list"
}
const _hoisted_11 = { class: "right_block" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h5", null, "Members", -1)
const _hoisted_13 = { class: "right_block__content" }
const _hoisted_14 = {
  key: 0,
  class: "members__list"
}
const _hoisted_15 = { class: "members__list__status" }
const _hoisted_16 = { class: "member_img" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "tw-w-full tw-flex tw-gap-3 tw-items-center tw-justify-end tw-pt-4 tw-border-t-dashed-custom" }
const _hoisted_19 = { class: "loader" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_UserProfileLogo = _resolveComponent("UserProfileLogo")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CommonLoader = _resolveComponent("CommonLoader")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return (_openBlock(), _createBlock(_component_CommonDialog, {
    isShowHeader: false,
    isShowBackButton: false,
    className: ['edit_specialism_modal'],
    width: "835px",
    height: "auto"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", null, "Edit Service for " + _toDisplayString($props.userSpecialismData?.label) + " Services", 1),
          _createVNode(_component_v_btn, {
            icon: "mdi-close",
            onClick: $setup.onClickCloseButton,
            variant: "text"
          }, null, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_icon, { icon: "mdi-hammer-wrench" }),
            _createElementVNode("h4", null, _toDisplayString($props.userSpecialismData?.label), 1)
          ]),
          (!$setup.loader)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_v_text_field, {
                      placeholder: "Search",
                      class: "search_field",
                      "bg-color": "#fff",
                      "prepend-inner-icon": "mdi-magnify",
                      variant: "outlined",
                      modelValue: $setup.searchSubCategories,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchSubCategories) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_9, [
                      ($setup.listOfSubCategory?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("ul", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterSubCategoryList, (subCategory) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: subCategory?.id
                                }, [
                                  _createVNode(_component_v_checkbox, {
                                    color: "indigo",
                                    modelValue: $setup.selectedSubCategory,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedSubCategory) = $event)),
                                    value: subCategory?.id
                                  }, null, 8, ["modelValue", "value"]),
                                  _createElementVNode("p", null, _toDisplayString(subCategory?.label), 1)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_v_text_field, {
                      placeholder: "Search",
                      class: "search_field",
                      "bg-color": "#fff",
                      "prepend-inner-icon": "mdi-magnify",
                      variant: "outlined",
                      modelValue: $setup.searchMembers,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.searchMembers) = $event))
                    }, null, 8, ["modelValue"]),
                    ($setup.teamMemberList?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("ul", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterTeamMemberList, (member) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: member?.id
                              }, [
                                _createVNode(_component_v_checkbox, {
                                  color: "indigo",
                                  modelValue: $setup.selectedMembers,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.selectedMembers) = $event)),
                                  value: member?.toUser?.id
                                }, null, 8, ["modelValue", "value"]),
                                _createElementVNode("div", _hoisted_16, [
                                  (member?.toUser?.profileURL)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: member?.toUser?.profileURL
                                      }, null, 8, _hoisted_17))
                                    : (_openBlock(), _createBlock(_component_UserProfileLogo, {
                                        key: 1,
                                        userName: `${member?.toUser?.firstName} ${member?.toUser?.lastName}`
                                      }, null, 8, ["userName"]))
                                ]),
                                _createElementVNode("p", null, _toDisplayString(member?.toUser?.firstName) + " " + _toDisplayString(member?.toUser?.lastName), 1)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_Button, {
              variant: "secondary",
              label: "Cancel",
              isCapitalize: true,
              onClick: $setup.onClickCloseButton,
              class: "!tw-w-auto"
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              variant: "accent",
              label: "SAVE",
              isCapitalize: true,
              onClick: $setup.onSave,
              isLoading: $setup.disabled,
              disabled: $setup.disabled || $setup.loader,
              class: "!tw-w-auto"
            }, null, 8, ["onClick", "isLoading", "disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          ($setup.loader)
            ? (_openBlock(), _createBlock(_component_CommonLoader, {
                key: 0,
                loading: $setup.loader
              }, null, 8, ["loading"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}